const webURL = 'https://demo.tenant.reposit.co.uk';
const clientId = '4scNcifsGng7zeS9EFADOPFSJQr7xUZW';
const paymentPlanPortalURL = 'https://demo.tenant-portal.reposit.co.uk';

export const appConfig = {
  links: {
    auth0: {
      logout: `https://reposit-demo.eu.auth0.com/v2/logout?client_id=${clientId}`,
      login: `https://reposit-demo.eu.auth0.com/authorize?response_type=token&client_id=${clientId}&redirect_uri=${webURL}/authenticate&audience=https://demo.api.com`,
    },
    local: {
      login: `${webURL}/login`,
    },
    paymentPlanPortal: paymentPlanPortalURL,
  },
  api: {
    basePath: 'https://demo.api.reposit.co.uk',
  },
  analytics: {
    trackers: [
      {
        name: 'demo',
        id: 'UA-81451405-5',
      },
    ],
  },
  stripe: {
    apiKey: 'pk_test_J0MDw0x6QrWhf4pLdKcVziuQ',
  },
  intercom: {
    appId: 's7plajks',
    enabled: true,
  },
  hotjar: {
    enabled: false,
    siteId: 0,
    hotjarVersion: 6,
  },
  trustPilot: {
    repositOfferTrustBoxEnabled: true,
  },
  inMaintenanceMode: false,
  sentry: {
    enabled: false,
    dsn: 'SENTRY_DSN_DEMO',
    environment: 'demo',
    tracesSampleRate: 1.0,
  },
};
